const caseStudies = [
  {
    title: "Scaling Multilingual Chatbots",
    description:
      "We helped a global tech firm train chatbots in 12 languages using culturally accurate data. " +
      "Our team ensured each language model understood local nuances, idioms, and context, which improved the chatbot's natural conversation capabilities. " +
      "The project included dialogue annotation, context tagging, and extensive QA to maintain high accuracy and cultural relevance."
  },
  {
    title: "Healthcare AI with Human Touch",
    description:
      "Our annotation team enabled a medical AI to detect rare conditions with 98% accuracy. " +
      "We provided meticulously labeled datasets covering radiology, pathology, and clinical notes, ensuring the AI could identify patterns in both common and rare cases. " +
      "Collaboration with healthcare professionals ensured ethical and safe data practices throughout the process."
  },
  {
    title: "Retail Voice Assistant",
    description:
      "We localized voice commands for a retail assistant across 8 regions, boosting adoption by 40%. " +
      "This involved translating voice intents, testing pronunciation variations, and integrating regional slang. " +
      "Our team optimized the assistant to respond naturally in each locale, enhancing user satisfaction and engagement."
  },
  {
    title: "Autonomous Vehicle Perception",
    description:
      "We provided annotated image and video datasets for training self-driving vehicle AI. " +
      "This included object detection, lane marking recognition, and pedestrian identification across various environmental conditions, improving safety and performance."
  },
  {
    title: "E-commerce Recommendation Engine",
    description:
      "We curated large-scale product datasets with user behavior metadata to enhance recommendation algorithms. " +
      "Our team focused on multilingual product descriptions, images, and user interactions to make the AI more personalized and globally relevant."
  }
];

export default function CaseStudies() {
  return (
    <section className="py-20 px-6 text-center">
      <h2 className="text-4xl font-extrabold mb-12 font-orbitron tracking-tight text-white">
        Case Studies / Success Stories
      </h2>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 text-left">
        {caseStudies.map((study, index) => (
          <div key={index}>
            <h3 className="text-2xl font-bold mb-2 text-cyan-400">{study.title}</h3>
            <p className="text-gray-200 leading-relaxed">{study.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
